var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAttachment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 30 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#717171",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M28.967 15.073 15.745 28.296A8.637 8.637 0 1 1 3.53 16.08L16.752 2.858a5.758 5.758 0 0 1 8.143 8.144L11.66 24.224a2.879 2.879 0 0 1-4.072-4.072l12.215-12.2"
})));
export default SvgAttachment;